import {useLayoutEffect,useRef} from 'react';
/** Display only: never changes serialized lesson data or grading IDs. */
export function russianTypography(text:string):string {
 if(!/[А-Яа-яЁё]/.test(text))return text;
 return text.replace(/(?<![А-Яа-яЁё])(в|с|к|о|у|и|а|я|не|на|по|за|из|от|до) +(?=\S)/giu,'$1\u00a0')
  .replace(/ +—/g,'\u00a0—').replace(/(\d+) +(?=[А-Яа-яЁё])/g,'$1\u00a0');
}
/** Covers text emitted inside existing renderers, without changing their data/contracts. */
export function useRussianTypography(enabled:boolean){
 const ref=useRef<HTMLElement|null>(null);
 useLayoutEffect(()=>{
  const root=ref.current;if(!enabled||!root)return;
  const update=()=>{const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let n:Node|null;while((n=walker.nextNode())){const old=n.nodeValue??'',next=russianTypography(old);if(next!==old)n.nodeValue=next;}};
  update();const observer=new MutationObserver(update);observer.observe(root,{childList:true,characterData:true,subtree:true});return()=>observer.disconnect();
 },[enabled]);
 return ref;
}
export function russianPayload<T>(value:T):T {
 if(typeof value==='string')return russianTypography(value) as T;
 if(Array.isArray(value))return value.map(russianPayload) as T;
 if(value&&typeof value==='object')return Object.fromEntries(Object.entries(value).map(([k,v])=>[k,russianPayload(v)])) as T;
 return value;
}
